import { BookingApplicationCheckoutState } from '@shared/types';
import { FunctionComponent } from 'react';
import { DateStep } from '../BookingFlow/DateStep';
import PriceStep from '../BookingFlow/PriceStep';
import { ContactDetailsStep } from '../../ContactDetailsStep';
import { ConfirmationStep } from './ConfirmationStep';
import { CheckoutFlowWrapper } from '../../CheckoutFlowWrapper';
import { useBookingApplicationCheckoutContext } from '../../CheckoutContext/BookingApplicationContext';

export type BookingApplicationFlowProps = {};

const unauthenticatedSteps: Array<{
    key: BookingApplicationCheckoutState['currentStep'];
    label: string;
}> = [
    {
        key: 'date',
        label: 'Date',
    },
    {
        key: 'price',
        label: 'Spaces',
    },
];

const authenticatedSteps: Array<{
    key: BookingApplicationCheckoutState['currentStep'];
    label: string;
}> = [
    {
        key: 'contactDetails',
        label: 'Contact Info',
    },
    {
        key: 'confirmation',
        label: 'Confirmation',
    },
];

const BookingApplicationStep: FunctionComponent<BookingApplicationFlowProps> = () => {
    const context = useBookingApplicationCheckoutContext();
    const { checkoutState } = context;

    switch (checkoutState.currentStep) {
        case 'date':
            return <DateStep {...context} />;

        case 'price':
            return <PriceStep {...context} />;

        case 'contactDetails':
            return <ContactDetailsStep />;

        case 'confirmation':
            return <ConfirmationStep />;
    }
};

export const BookingApplicationFlow: FunctionComponent<BookingApplicationFlowProps> = () => {
    return (
        <CheckoutFlowWrapper
            authenticatedSteps={authenticatedSteps}
            unauthenticatedSteps={unauthenticatedSteps}
        >
            <BookingApplicationStep />
        </CheckoutFlowWrapper>
    );
};
